export default __webpack_public_path__ + "/dist/images/restaurent-contentimg.0a8b9982b6769f20baf8d42296c9dbbe.png";